import {Component, Inject, OnInit} from '@angular/core';
import {VehicleCategoryModel} from '../../../../../shared/models/vehicle';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import {VehicleModel} from '../../../../../shared/models/vehicle.model';
import {VehiclesService} from '../../../../../data/vehicles/vehicles.service';
import {ToastService} from '../../../../../shared/services/toast.service';
import {firstValueFrom} from 'rxjs';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { UiBlockingLayerComponent } from '../../ui-blocking-layer/ui-blocking-layer.component';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-dialog-move-vehicle',
  templateUrl: 'dialog-move-vehicle.html',
  styleUrls: ['./dialog-components.scss'],
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatRadioGroup,
    FormsModule,
    MatRadioButton,
    UiBlockingLayerComponent,
    MatProgressBar,
    MatDialogActions,
    MatButton,
    MatDialogClose,
  ],
})
export class DialogMoveVehicleComponent implements OnInit {
  groups: VehicleCategoryModel[];
  vehicleGroup: VehicleCategoryModel;
  originalGroupId: number;

  /**
   * Indicates an active background network operation.
   */
  protected isWorking = false;

  constructor(
    public dialogRef: MatDialogRef<DialogMoveVehicleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: VehicleModel,
    private vehicleService: VehiclesService,
    protected toastService: ToastService
  ) {
    // dialogRef.addPanelClass('use-material-design-3-theme');
    this.originalGroupId = data.groupId;
  }

  ngOnInit() {
    // TODO: Indicate that we are waiting for some data to load
    this.vehicleService
      .getVehicleCategories()
      .then(groups => {
        this.groups = groups;
        this.vehicleGroup = this.groups.find(group => this.originalGroupId === group.id);
      })
      .catch(error => {
        // TODO: Let the user know. At least a toast and close the dialog?
        console.log(error);
      });
  }

  canMove(): boolean {
    return this.vehicleGroup?.id !== undefined && this.originalGroupId !== this.vehicleGroup.id;
  }

  saveChanges() {
    const vehicleModel = this.data;
    vehicleModel.groupId = this.vehicleGroup.id;

    this.isWorking = true;
    const disableCloseStateToRestore = this.dialogRef.disableClose;
    this.dialogRef.disableClose = true;

    firstValueFrom(this.vehicleService.updateVehicle(vehicleModel.id, vehicleModel))
      .then(response => {
        const updatedVehicle = response.data;
        this.dialogRef.close(updatedVehicle);
      })
      .catch(saveError => {
        console.warn('Vehicle failed to move.', saveError);
        this.toastService.short('Vehicle failed to move.');
      })
      .finally(() => {
        this.isWorking = false;
        this.dialogRef.disableClose = disableCloseStateToRestore;
      });
  }
}
